import BossModel from "@/models/BossModel";
import Airport from "@/models/Airport/Airport";
import Classification from "@/models/Dossier/Ticket/Flight/Classification/Classification";
import {mutateDateTimeWithoutSeconds} from "@/utils/mutators";
import Airline from "@/models/Airline/Airline.js";

export default class Flight extends BossModel {

    static apiUrl = 'dossier/ticket/flight';

    static entity = 'dossierTicketFlights';

    static fields() {
        return {
            id: this.number(null).nullable(),
            airport_departure_id: this.number(null).nullable(),
            airport_arrival_id: this.number(null).nullable(),
            airline_id: this.number(null).nullable(),
            airline_name: this.attr(null),
            operated_by: this.attr(null),
            booking_class: this.attr(null),
            dossier_ticket_flight_classification_id: this.number(null).nullable(),
            departures_at: this.attr(null),
            arrives_at: this.attr(null),
            departures_from: this.attr(null),
            departs_to: this.attr(null),
            flight_number: this.attr(null),
            reservation_code: this.attr(null),
            arrives_next_day: this.boolean(0),
            departure: this.belongsTo(Airport, 'airport_departure_id'),
            arrival: this.belongsTo(Airport, 'airport_arrival_id'),
            classification: this.belongsTo(Classification, 'dossier_ticket_flight_classification_id'),
            airline: this.belongsTo(Airline, 'airline_id'),
        }
    }

    static mutators () {
        return {
            departures_at: mutateDateTimeWithoutSeconds,
            arrives_at: mutateDateTimeWithoutSeconds,
        }
    }
}
